// feedConstants.js
'use strict';

export const OPTION_UNSET = 'unset';

export const QueryType = {
  FILTER: 'filter',
  SORT: 'sort',
};
export const QueryPrefix = {
  [QueryType.FILTER]: 'FILTERS',
  [QueryType.SORT]: 'SORTINGS',
};

export const QUERY_STRING_KEY = '_q';
export const QUERY_SEPARATOR = ',';
export const SUPPORTED_FEED_QUERIES = ['sorting', 'filters'];

export const FeedNameType = {
  USERS: 'users',
  HASHTAGS: 'hashtags',
  MESSAGES: 'messages',
};

export const HomeCategoryUi = {
  FLIX: 'flix',
  FLIX_GRID: 'flix-grid',
  LIVESTREAM: 'livestream',
  LIVESTREAM_GRID: 'livestream-grid',
  SHORTS: 'shorts',
  STORY: 'story',
  STORY_GRID: 'story-grid',
  USER: 'user',
};
